/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */

import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import  '../node_modules/bootstrap/js/src/collapse.js';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';
import 'bootstrap-touchspin';
import './lib/slick.min';
import './lib/jquery.hoverIntent.min';
import './lib/modernizr.touch.min';
import SlickSlider from './components/slick';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './filters';
import './navigation';
import './product';
import './cart';
import './blog';

import Form from './components/form';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';


import './components/block-cart';
import lazysizes from 'lazysizes'


// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  const test = 270479;
  const form = new Form();
  let slickSlider = new SlickSlider();
  //let topMenuEl = $('#_desktop_top_menu #top-menu');
  //let topMenu = new TopMenu(topMenuEl);

  form.init();
  slickSlider.init();
  //topMenu.init();

  //display input file content in custom file input BS
  $('.custom-file-input').on('change',function(){
      let fileName = $(this).val().split('\\').pop();
      $(this).next('.custom-file-label').addClass("selected").html(fileName);
  })

  $(window).scroll(function() {
    var stickyContacts = $('#contact-widget-wrapper');
    if (Math.round(window.scrollY) >= ($(document).height() - window.innerHeight)) {
        stickyContacts.fadeOut();
    } else {
        stickyContacts.fadeIn();
    }
  });

  if (prestashop.page.page_name !== 'checkout') {
    zE(function() {
      zE.hide();
    });

    $('#activateZendesk').on('click', function(e) {
        e.preventDefault();
        zE.activate();
    });
  
    checkCompareItems();
    $(document).ajaxComplete(function(event, jqXHR, ajaxOptions) {
        setTimeout(function(){ 
          checkCompareItems();
        }, 500);   
    });
  }

});

function checkCompareItems() {
  if ($('#cdpcp-items .cdpcp__item').length) {
    $('#contact-widget-wrapper').css('right', $('#cdproductcomparisonplus.cdpcp').width() + 'px');
  } else {
    $('#contact-widget-wrapper').css('right', '0');
  }
}

document.addEventListener('lazyloaded', function(e){
    $(e.target).parent().addClass('rc--lazyload');
    var bg = e.target.getAttribute('data-bg-product');
    if(bg){
      setTimeout(function(){ e.target.style.backgroundImage = 'url(' + bg + ')'; }, 1000); 
    }
});
document.addEventListener('lazybeforeunveil', function(e){
  var bg = e.target.getAttribute('data-bg');
  if(bg){
      e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});